// extracted by mini-css-extract-plugin
module.exports = {"labelsTable":"builder__labelsTable__bFUQo"};